import React from 'react';

interface SceneBackgroundProps {
  children?: React.ReactNode;
}

export const SceneBackground: React.FC<SceneBackgroundProps> = ({ children }) => {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Base gradient layer */}
      <div
        className="fixed inset-0"
        style={{
          background: `
            radial-gradient(1000px 600px at 12% 10%, rgba(0, 255, 157, 0.18), transparent 60%),
            radial-gradient(800px 520px at 88% 14%, rgba(15, 243, 127, 0.14), transparent 55%),
            linear-gradient(180deg, #060a08 0%, #040606 45%, #0a1511 100%)
          `,
          zIndex: -3
        }}
      />

      {/* Pattern grid (tech texture) */}
      <div
        className="fixed inset-0"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2300ff9d' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
          opacity: 0.18,
          zIndex: -2
        }}
      />

      {/* Subtle grid lines */}
      <div
        className="fixed inset-0"
        style={{
          backgroundImage: `
            linear-gradient(rgba(0,255,157,0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,255,157,0.03) 1px, transparent 1px)
          `,
          backgroundSize: '180px 180px',
          opacity: 0.09,
          zIndex: -2
        }}
      />

      {/* Scanline texture */}
      <div
        className="fixed inset-0"
        style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)',
          backgroundSize: '100% 6px',
          opacity: 0.08,
          zIndex: -2
        }}
      />
      {/* Paper noise */}
      <div
        className="fixed inset-0"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='120' height='120' filter='url(%23n)' opacity='0.15'/%3E%3C/svg%3E\")",
          opacity: 0.06,
          zIndex: -2
        }}
      />

      {/* Glow orbs */}
      <div className="fixed inset-0" style={{ zIndex: -2 }}>
        <div className="absolute top-1/4 left-[10%] w-[520px] h-[520px] bg-green-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-[8%] w-[520px] h-[520px] bg-emerald-500/10 rounded-full blur-3xl" />
      </div>

      {/* Vignette overlay */}
      <div 
        className="fixed inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at center, rgba(0,0,0,0) 0%, rgba(0,0,0,0.55) 100%)',
          zIndex: -1
        }}
      />

      {/* Content */}
      <div className="relative" style={{ zIndex: 1 }}>
        {children}
      </div>
    </div>
  );
};
